import Button, { ButtonGroup } from '@datacamp/waffles-button';
import { UndoIcon } from '@datacamp/waffles-icons';
import cx from 'classnames';
import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const ControlBar = _ref => {
  let {
    className,
    disabled,
    loading,
    onReset,
    onSubmit,
    submitLabel = 'Submit Answer'
  } = _ref;
  return ___EmotionJSX("div", {
    className: cx('dc-u-fxi-f-none dc-u-p-8 dc-u-fx dc-u-fx-jcfe dc-u-fx-aic', className)
  }, ___EmotionJSX(ButtonGroup, null, ___EmotionJSX(Button, {
    ariaLabel: "Reset",
    dataAttributes: {
      cy: 'reset-button'
    },
    disabled: disabled,
    loading: loading,
    onClick: onReset,
    size: "small"
  }, ___EmotionJSX(UndoIcon, null)), ___EmotionJSX(Button, {
    appearance: "primary",
    dataAttributes: {
      cy: 'submit-button'
    },
    disabled: disabled,
    intent: "success",
    loading: loading,
    onClick: onSubmit,
    size: "small"
  }, submitLabel)));
};